module.exports = __webpack_public_path__ + "img/lerner-makerlab-logo.5540c2f1.svg";